"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.degToRad = degToRad;
exports.radToDeg = radToDeg;
exports.knotsToMeterPerSecond = knotsToMeterPerSecond;
exports.meterPerSecondToKnots = meterPerSecondToKnots;
exports.knotsToKmPerHour = knotsToKmPerHour;
exports.kmPerHourToKnots = kmPerHourToKnots;
/**
 * Convert an angle in degrees into an angle in radians
 * @param {number} angle   An angle in degrees
 * @return {number} Returns an angle in radians
 */
function degToRad(angle) {
  return angle * Math.PI / 180;
}

/**
 * Convert an angle in radians into an angle in degrees
 * @param {number} angle  An angle in radians
 * @return {number} Returns an angle in degrees
 */
function radToDeg(angle) {
  return angle * 180 / Math.PI;
}

/**
 * Convert a speed in knots into a speed in meter per second
 * 1 knot is 0.514444 m/s
 * @param {number} knots 
 * @return {number} Returns speed in m/s
 */
function knotsToMeterPerSecond(knots) {
  return knots * 0.514444;
}

/**
 * Convert a speed in meter per second into a speed in knots
 * 1 knot is 0.514444 m/s
 * @param {number} knots 
 * @return {number} Returns speed in m/s
 */
function meterPerSecondToKnots(meterPerSecond) {
  return meterPerSecond / 0.514444;
}

/**
 * Convert a speed in knots into a speed in kilometer per hour
 * 1 knot is 1.852 kilometer per hour
 * @param {number} knots   A speed in knots
 * @return {number} Returns speed in km/h
 */
function knotsToKmPerHour(knots) {
  return knots * 1.852;
}

/**
 * Convert a speed in kilometer per hour into a speed in knots
 * 1 knot is 1.852 kilometer per hour
 * @param {number} kmPerHour   A speed in km/h
 * @return {number} Returns speed in knots
 */
function kmPerHourToKnots(kmPerHour) {
  return kmPerHour / 1.852;
}